const Hero = () => {
  return (
    <div className="pt-32  px-6 text-center">
      <div className="bg-neutral-900/60 p-4 rounded-t-3xl">
        <h1 className="text-2xl md:text-4xl font-bold text-white mb-4">
          Welcome to Octant
        </h1>
        <p className="text-md text-white">
          Engineered for performance, built to last
        </p>
      </div>
    </div>
  );
};

export default Hero;